import React, { useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const IntentBehaviorContext = /*#__PURE__*/React.createContext({
  getDisabled: () => false,
  getTooltip: () => null
});
export const useIntentBehavior = () => useContext(IntentBehaviorContext);
export const IntentBehaviorProvider = _ref => {
  let {
    children,
    value
  } = _ref;
  return /*#__PURE__*/_jsx(IntentBehaviorContext.Provider, {
    value: value,
    children: children
  });
};